/** @format */
import styled from 'styled-components';

export const StyledCompleteCheckoutControl = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: var(--layout-spacing-16);

    .payment-error {
        width: 100%;
    }
`;
